/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
import { memo, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { dashboardLeadCall } from "src/services/Dashboard";
import store from "src/redux/store";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { setDashboardData, setLimit, setPageNo, setTableData } from "src/redux/Actions/dashboard";
import { rowData } from "src/helpers/Dashboard/tableData";
import { constructFilterQuery, dashboardSearchOnMapper } from "src/helpers/Dashboard";
import CustomLoader from "src/shared/CustomLoader";
import { useDispatch } from "react-redux";
import { MasterAction } from "src/redux/Actions/Masters";
import { SET_PRODUCT, SET_PRODUCT_PARTNER } from "src/redux/Types/Masters";
import { product } from "src/services/Master";
import Button from "@mui/material/Button";
import ApplicationsTable from "./ApplicationsTable";
import TablePagination from "./TablePagination";
import QueryOptions from "./QueryOptions";

function Dashboard() {
  const [apiError, setApiError] = useState<Error | null>(null);
  const [productsApiError, setProductsApiError] = useState<Error | null>(null);
  const pageNo = useAppSelector((state) => state.dashboard.pageNo);
  const limit = useAppSelector((state) => state.dashboard.limit);
  const sortBy = useAppSelector((state) => state.dashboard.sortBy);
  const filterBy = useAppSelector((state) => state.dashboard.filterOptions);
  const search = useAppSelector((state) => state.dashboard.searchQuery);
  const searchOn = useAppSelector((state) => state.dashboard.searchOn);
  const dateFilters = useAppSelector((state) => state.dashboard.dateFilters);
  const tableDataLength = useAppSelector(
    (state) => Object.keys(state.dashboard?.data?.data || {})?.length
  );
  const sortByConcat = Object.entries(sortBy)
    .map((entry) => entry.join(":"))
    .join(",");
  const {
    isFetching,
    refetch,
    isLoading: isDashboardAPILoading
  } = useQuery(
    ["dashboard", dateFilters],
    async () => {
      const filterByOptions = await constructFilterQuery(filterBy);
      return dashboardLeadCall(
        limit,
        sortByConcat,
        pageNo,
        filterByOptions,
        search,
        dashboardSearchOnMapper[searchOn],
        dateFilters
      );
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
      enabled:
        dateFilters?.startDate || dateFilters?.endDate
          ? !!(dateFilters?.startDate && dateFilters?.endDate)
          : true,
      onSuccess: async (response) => {
        store.dispatch(setDashboardData(response.data));
        const rowsMapping = await rowData(response.data);
        store.dispatch(setTableData(rowsMapping));
        if (!response.data?.data?.length) {
          store.dispatch(setLimit(8));
          store.dispatch(setPageNo(1));
        }
        setApiError(null);
      },
      onError: (error: unknown) => {
        setApiError(error instanceof Error ? error : new Error("No Record Found"));
      }
    }
  );

  // All Product Api call

  const dispatch = useDispatch();
  const fetchProducts = async () => {
    try {
      const data = await product();
      dispatch(MasterAction(SET_PRODUCT, data));
      dispatch(MasterAction(SET_PRODUCT_PARTNER, data));
      setProductsApiError(null);
    } catch (error) {
      setProductsApiError(error instanceof Error ? error : new Error("No Record Found"));
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    console.log("refetch called");
    refetch();
  }, [pageNo, limit, sortBy, filterBy, search]);

  // console.log("window location  ", window.location.href);
  // console.log("local ", window.location.href.includes("localhost"));
  // console.log("dev ", window.location.href.includes("aflimrtadevfe"));
  // console.log("sit ", window.location.href.includes("aflimrtafesit"));
  // console.log("uat ", window.location.href.includes("sacimrtnp01"));

  const handleRetry = () => {
    if (apiError) {
      refetch();
    } else if (productsApiError) {
      fetchProducts();
    }
  };

  if (apiError || productsApiError) {
    const errorMessage =
      apiError && productsApiError
        ? `Record not found: ${apiError.message}`
        : apiError?.message || productsApiError?.message || "No Record Found";

    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <div className="mt-10 mb-10 text-2xl font-bold text-center text-hotShot">
          {errorMessage}
        </div>
        <Button
          variant="contained"
          classes={{ contained: "!rounded-lg" }}
          className="!uppercase m-auto"
          onClick={handleRetry}
        >
          RETRY
        </Button>
      </div>
    );
  }

  if (isFetching) {
    return <CustomLoader />;
  }

  if (!isDashboardAPILoading) {
    return (
      <div className="mx-auto md:my-6 md:w-95/100">
        <div
          className={`bg-white py-2 md:px-7 md:border border-palladium md:rounded-t-md ${
            !tableDataLength ? "md:rounded-b-md" : ""
          } mx-auto`}
        >
          <QueryOptions />
        </div>
        {tableDataLength ? (
          <>
            <div>
              <ApplicationsTable />
            </div>
            <div className="px-4 py-2 mx-auto bg-white md:border border-palladium border-t-white md:rounded-b-md">
              <TablePagination />
            </div>
          </>
        ) : (
          !isFetching && (
            <div className="mt-10 text-2xl font-bold text-center text-hotShot">
              No Records Found
            </div>
          )
        )}
      </div>
    );
  }

  return null;
}

export default memo(Dashboard);
